import { render } from "./ContactForms.vue?vue&type=template&id=2d4135f6&scoped=true"
import script from "./ContactForms.vue?vue&type=script&lang=js"
export * from "./ContactForms.vue?vue&type=script&lang=js"

import "./ContactForms.vue?vue&type=style&index=0&id=2d4135f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4135f6"]])

export default __exports__